module.exports = __webpack_public_path__ + "img/leveler-3-on.c993e3e9.png";